module.exports = {"type":"Official Plan","official":[{"name":"Official Plan Land Use","layer":"toronto op","toggle":false,"names":["Toronto OP","York Region Single"]}],"secondary":[{"name":"Secondary Plan","toggle":false,"names":["Secondary Op","Secondary Accuracy Op"]}],"officialInfo":[{"devError":"","policyError":"","error":"","policySecond":[],"dev_sumtitle":[]}],"secondaryInfo":[{"error":""}]}


//////////////////
// WEBPACK FOOTER
// ./public/data/oplu_sidebar.json
// module id = 9Tby
// module chunks = 1